import { DividendYieldVsMarketTable } from './DividendYieldVsMarketTable';

export default DividendYieldVsMarketTable;
